import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import useGameStore from '@/store/gameStore';
import apiService from '@/services/api';
import Lobby from '@/components/Lobby';
import GameRoom from '@/components/GameRoom';
import LoadingSpinner from '@/components/LoadingSpinner';

function App() {
  const { isAuthenticated, setUser, setLoading, isLoading } = useGameStore();

  useEffect(() => {
    // Check authentication on mount
    const checkAuth = async () => {
      setLoading(true);
      try {
        const currentUser = await apiService.getCurrentUser();
        setUser(currentUser);
      } catch (error) {
        console.error('Auth check failed:', error);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [setUser, setLoading]);

  if (isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  // Cloudflare Access handles authentication, so we don't need login screen
  // If user reaches here, they're already authenticated by Cloudflare Access
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100">
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? <Navigate to="/lobby" replace /> : <LoadingSpinner fullScreen />
          }
        />
        <Route
          path="/lobby"
          element={isAuthenticated ? <Lobby /> : <LoadingSpinner fullScreen />}
        />
        <Route
          path="/room/:roomId"
          element={isAuthenticated ? <GameRoom /> : <LoadingSpinner fullScreen />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
